<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="620px">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>ĐẶT SỐ TÚI</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="d-flex">
                Xin vui lòng điền số túi:
                <v-text-field
                  class="mx-2"
                  v-model="roomCode"
                  label="Số túi"
                  :rules="[$rules.required]"
                  dense
                  outlined
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="openConfirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDialog" persistent max-width="620px">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>XÁC NHẬN THAO TÁC</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeConfirm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <p class="ma-0">
            <span style="color: red"
              ><strong><i>(*)Lưu ý: </i></strong></span
            >Thao tác này sẽ đánh số túi cho phòng này<br />
            Bạn có chắc là bạn muốn thực hiện thao tác không?
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn color="blue darken-4" text @click="closeConfirm" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="confirm()">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { RoomSubject } from '../../plugins/api'
export default {
  props: {
    data: Object,
    state: Boolean
  },
  components: {},
  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
        this.progressDialog = false
      }
    },
    data: {
      immediate: true,
      handler(newVal) {
        this.setDefaultValues(newVal)
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      confirmDialog: false,
      roomCode: ''
    }
  },
  methods: {
    cancel() {
      this.$emit('closeDialog')
    },
    openConfirm() {
      this.confirmDialog = true
    },
    closeConfirm() {
      this.confirmDialog = false
    },
    closeInvalid() {
      this.invalidDialog = false
      this.invalidCodes = ''
    },
    async confirm() {
      this.$loading.active = true
      const data = {
        id: this.data.id,
        roomCode: this.roomCode,
        room: this.data.room.id,
        subject: this.data.subject.id
      }
      const indexing = await RoomSubject.assignRoomCode(data)
      if (indexing) {
        if (indexing.existedCode) {
          this.$alert.error('Số túi đã tồn tại. Xin vui lòng kiểm tra lại!')
          this.closeConfirm()
          this.loading = false
        } else {
          this.$alert.success('Đánh số túi thành công')
          this.$emit('refresh')
          this.closeConfirm()
          this.cancel()
        }
      } else {
        this.$alert.error('Lỗi đánh số túi')
        this.closeConfirm()
      }
      this.$loading.active = false
    },
    setDefaultValues(data) {
      if (data) {
        this.roomCode = data.roomCode || ''
      }
    }
  }
}
</script>
